import Classes from "./CountForm.module.css"

export const HeadsCountForm = () => {


  return <div className={Classes.main_div}>This is the heads count form</div>
}
